import Vue from 'vue';
import VueRouter from 'vue-router';
// import { getToken } from './token';
import Layout from '../views/Layout/Layout.vue';
import Login from '../views/Login.vue';
import Register from '../views/Register.vue';
import ForgotPassword from '../views/ForgotPassword.vue';
import Items from '../views/Items.vue';
import Orders from '../views/Orders.vue';

import Cookies from 'js-cookie';

Vue.use(VueRouter);

const routes = [
    {
        path: '/login',
        component: Login,
        name: 'Login'
    },
    {
        path: '/register',
        component: Register,
        name: 'Register'
    },
    {
        path: '/forgot-password',
        component: ForgotPassword,
        name: 'ForgotPassword'
    },
    {
        path: '/',
        component: Layout,
        name: 'Layout',
        redirect: '/home',
        children: [
            {
                path: '/home',
                component: Items
            },
            {
                path: '/orders',
                component: Orders
            }
        ]
    }
];

const Router = new VueRouter({
    routes
});

Router.beforeEach((to, from, next) => {
    if (to.fullPath === '/login') {
        let isGuest = Cookies.get('_backend_identity_isGuest');
        if (isGuest !== undefined) {
            next();
        } else {
            next('/');
        }
    } else {
        next();
    }
});

export default Router;